<template>
  <div class="row">
    <div class="col-sm-2 sdbr">
      <Sidebar />
    </div>
    <div class="col-sm-10">
      <div class="row pt-3">
        <div class="col-sm-12">
          <i class="fa fa-angle-double-left" @click="setPrevRoute"></i>
        </div>
        <div class="col-sm-12 userttl text-center">User Info</div>
      </div>
      <!-- <div class="row d-flex justify-content-end">
        <div class="input-group col-sm-4">
          <input
            type="text"
            class="form-control"
            placeholder="Search user by email or key"
            aria-describedby="basic-addon2"
          />
          <div class="input-group-append">
            <button class="btn btn-success" type="button">
              Go!
            </button>
          </div>
        </div>
      </div> -->
      <div class="col-sm-12">
        <div class="row">
          <div class="col-sm-12 user-info mt-3">
            {{ userInfo.name }}
          </div>
        </div>
        <div class="row">
          <table class="table table-bordered">
            <thead>
              <tr>
                <th scope="col">Email</th>
                <th scope="col">Key</th>
                <th scope="col">Plan</th>
                <th scope="col">Company</th>
                <th scope="col">Last Activity</th>
                <th scolpe="col">Onboarding Date</th>
              </tr>
            </thead>
            <tbody class="tab-data">
              <tr>
                <td>{{ userInfo.email }}</td>
                <td>
                  <small>{{ userInfo.key ? userInfo.key : userKey }}</small>
                </td>
                <td>{{ getUserPlan(userInfo) }}</td>
                <td>{{ userInfo.company }}</td>
                <td>{{ lastCall }}</td>
                <td>{{ userInfo.onboardingDate }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="row p-2">
        <div class="col-sm-12 py-4 brdrad shdw">
          <div class="row">
            <div class="col-sm-12">
              <div>
                <Timeframe v-on:timeFrameEmit="getCount" :filter="filterObj" />
              </div>
              <Usersummary :userTrans="userTrans.stats" v-if="userTrans" />
            </div>
          </div>
          <div class="row d-flex pt-5">
            <div class="col-sm-12 text-center p-1">
              <h4>Call Activity</h4>
            </div>
            <div class="col-sm-2 offset-sm-10">
              <select
                class="form-control m-1"
                v-model="param"
                @click="setChartData(param)"
              >
                <option value="Total">Total</option>
                <option value="Air">Air</option>
                <option value="Pollen">Pollen</option>
                <option value="Weather">Weather</option>
                <option value="Soil">Soil</option>
                <option value="Water">Water</option>
                <option value="Fire">Fire</option>
                <option value="All">All</option>
              </select>
            </div>
            <div class="col-sm-12">
              <Userchart :data="chartData" :param="param" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Sidebar from "./sidebar.vue";
import Timeframe from "./Timeframe.vue";
import Userchart from "./Userchart.vue";
// import Summary from "./Summary.vue";
import Usersummary from "./Usersummary.vue";
import moment from "moment";
import _ from "underscore";
export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from;
    });
  },
  mounted() {
    this.getUserLastUsed(this.$route.params.userId);
    this.filterObj = {
      custom: this.$route.query.custom,
      days: this.$route.query.days,
      from: this.$route.query.from,
      to: this.$route.query.to,
    };
    this.getUser();
    // if(this.startDt && this.endDt)
    this.getUserActivity(this.$route.query.from, this.$route.query.to);
    this.getUserHistory(
      this.userKey,
      this.$route.query.from,
      this.$route.query.to
    );
  },
  data() {
    return {
      userKey: this.$route.params.userId,
      lastRoute: "",
      lastPath: "",
      userInfo: "",
      userData: [],
      userTrans: [],
      lastCall: "",
      userHist: "",
      showHist: true,
      param: "Total",
      chartData: [],
      xAxis: [],
      startDt: "",
      endDt: "",
      day: "today",
      filterObj: { custom: false, days: 1 },
    };
  },
  components: {
    Sidebar,
    Timeframe,
    Userchart,
    // Summary,
    Usersummary,
  },
  methods: {
    getUser() {
      // const uri = `http://localhost:3002/apiuser/user-info?key=${this.userKey}`;
      const uri = `http://13.235.254.91:5000/apiuser/user-info?key=${this.userKey}`;
      this.$http(uri).then((result) => {
        let data = result.data.data[0];
        this.userInfo = {
          name: data.name,
          email: data.email,
          key: data.aws_key.value,
          company: data.company || "NA",
          onboardingDate: moment(data.aws_key.createdDate).format(
            "Do MMM YYYY"
          ),
          planId: data.planId,
        };
      });
    },
    getUserLastUsed(key) {
      // const uri = `http://localhost:3002/apiuser/user-latestcall?key=${this.userKey}`;
      const uri = `http://13.235.254.91:5000/apiuser/user-latestcall?key=${this.userKey}`;
      this.$http(uri).then((result) => {
        let lastCallObj = result.data.data[0];
        let lastCall = result.data.data[0].recentAPICall;
        this.lastCall = lastCall ? moment(lastCall).fromNow() : "No Activity";
      });
    },
    getCount(num) {
      this.filterBy(num);
    },
    getUserActivity(start, end) {
      // const uri = `http://localhost:3002/apiuser/user-activity?key=${this.userKey}&start=${start}&end=${end}`;
      const uri = `http://13.235.254.91:5000/apiuser/user-activity?key=${this.userKey}&start=${start}&end=${end}`;
      this.$http(uri).then((result) => {
        this.userTrans = {
          stats: result.data.data.length ? result.data.data[0] : [],
          startDt: this.startDt,
          endDt: this.endDt,
        };
      });
    },
    getUserHistory(userkey, start, end) {
      // const uri = `http://localhost:3002/apiuser/user-history?key=${this.userKey}&start=${start}&end=${end}`;
      const uri = `http://13.235.254.91:5000/apiuser/user-history?key=${this.userKey}&start=${start}&end=${end}`;
      this.$http(uri).then((result) => {
        this.userHist = result.data.data;
        this.setChartData('Total');
      });
    },
    filterBy(d) {
      let num = d.num;
      this.startDt = d.startDt;
      this.endDt = d.endDt;
      this.day = d.day;
      this.getUser();
      this.getUserActivity(this.startDt, this.endDt);
      this.getUserHistory(this.userKey, this.startDt, this.endDt);
    },
    async setChartData(param) {
      // let param = this.param;
      // this.chartData = this.userHist.map((elm) =>
      //   [elm[param],moment(moment.utc(elm.timestamp).toDate()).add(6, 'hours').toDate().getTime()].reverse()
      // );
      // this.chartData = this.userHist.map((elm) =>
      //   [elm[param], new Date(elm.istTime).getTime()].reverse()
      // );
       let chartData = await this.userHist.filter((elm) => {
        return elm.category === param;
      }); 
      this.chartData = chartData.map((elm) => {
      return [elm.count,new Date(elm.createdAt).getTime()].reverse()
      }); 
    },
    getUserPlan(userInfo) {
      if (!userInfo) {
        return "Custom";
      } else if (userInfo.planId === "obalx7") {
        return "Free";
      } else if (userInfo.planId === "zz5dnf" || userInfo.planId === "NA") {
        return "Custom";
      } else {
        return "Pay as you go";
      }
    },
    setPrevRoute() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped>
.tab-data {
  font-size: 0.9rem;
}
.userttl {
  font-family: Ubuntu;
  color: rgba(59, 59, 59, 0.8);
  font-weight: 500;
  font-size: 1.6rem;
}
.user-info {
  font-size: 1.5rem;
  text-transform: capitalize;
  color: #e91e63;
}
</style>